<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">矩阵管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/goodsList' }">
          <div class="div1">平台列表</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">平台查看</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content page-title">
      <h2>平台查看</h2>
    </div>
    <div class="content">
      <h3>平台管理</h3>
      <el-form :model="infoForm" :rules="infoRules" ref="infoForm" label-width="140px" class="info-form">
        <el-form-item label="关联用户" prop="userId">
          <div>
            <div>姓名：{{ infoForm.username }}</div>
            <div>ID:{{ infoForm.userId }}</div>
            <div>电话:{{ infoForm.userPhone }}</div>
            <!-- <el-input
              placeholder="请选择用户"
              v-model="infoForm.userId"
              style="width: 30%"
              @focus="selectUser"
              readonly
            ></el-input> -->
          </div>
        </el-form-item>
        <el-form-item label="用户等级"><el-select style="width: 30%" v-model="infoForm.vipLevel" placeholder="请选择用户等级"
            filterable clearable disabled>
            <el-option v-for="item in dictionaries.platform_vip_level" :key="item.dictId" :label="item.dictName"
              :value="item.dictId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="display: none"> </el-form-item>
        <el-form-item label="平台类型" prop="type"><el-select style="width: 30%" v-model="infoForm.type" disabled
            placeholder="请选择平台类型" clearable>
            <el-option label="矩阵小程序" value="0"></el-option>
            <el-option label="投流小程序" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台类目" prop="categoryIds" v-if="infoForm.type == 0">
          <el-cascader disabled placeholder="请选择平台类目" style="width: 30%" :options="categoryList"
            v-model="infoForm.categoryIds" :props="{ multiple: true, checkStrictly: true, emitPath: false }"
            @change="onChangeCategory" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="平台名称" prop="name">
          <el-input disabled placeholder="请输入平台名称" v-model="infoForm.name" style="width: 30%" maxlength="15"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <div :style="{
            color: infoForm.statusLabel == '已上线' ? '#12AB62' : 'red',
          }">
            {{ infoForm.statusLabel }}
          </div>
        </el-form-item>

        <el-form-item label="平台图片" prop="logoUrl">
          <el-image :src="infoForm.logoUrl" style="width: 120px; height: 120px" @click="look(infoForm.logoUrl)">
          </el-image>
          <!-- <headerPicture
            @getUrl="getImage($event)"
            :qrCodeUrl="infoForm.logoUrl"
          ></headerPicture> -->
          <!-- <div>建议图片规格：160像素*160像素，格式：PNG、JPG</div> -->
        </el-form-item>
        <el-form-item label="平台简介" prop="intro">
          <el-input disabled type="textarea" v-model="infoForm.intro" placeholder="请输入平台简介" style="width: 30%"
            maxlength="120" show-word-limit :rows="5">
          </el-input>
          <!-- <quill-editor
            style="width: 80%"
            v-model="infoForm.intro"
            ref="myQuillEditor"
            :options="editorOption"
            class="editor"
          ></quill-editor> -->
        </el-form-item>
        <el-form-item label="平台管理员电话" prop="adminPhone">
          <div>
            <el-input disabled style="width: 30%" placeholder="请输入电话" v-model="infoForm.adminPhone"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="管理员身份证" prop="adminIdCardFront">
          <!-- <div>建议图片格式：PNG、JPG，5M以内</div> -->
          <el-image :src="infoForm.adminIdCardFront" style="width: 300px; height: 150px"
            @click="look(infoForm.adminIdCardFront)">
          </el-image>
          <el-image :src="infoForm.adminIdCardContrary" style="width: 300px; height: 150px; margin-left: 18px"
            @click="look(infoForm.adminIdCardContrary)">
          </el-image>
          <!-- <upload-means
            type="1"
            @getUrl="getUrl($event, '1')"
            :managerIdentifyTop="infoForm.adminIdCardFront"
          ></upload-means>
          <upload-means
            style="margin-left: 18px"
            type="2"
            @getUrl="getUrl($event, '2')"
            :managerIdentifyBottom="infoForm.adminIdCardContrary"
          ></upload-means> -->
        </el-form-item>
        <!-- <el-form-item label="管理员身份证反面" prop="adminIdCardContrary">
          <upload-means
            type="2"
            @getUrl="getUrl($event, '2')"
            :managerIdentifyBottom="infoForm.adminIdCardContrary"
          ></upload-means>
          <div>建议图片规格：160像素*160像素，格式：PNG、JPG</div>
        </el-form-item> -->
        <el-form-item label="营业执照">
          <!-- <div>建议图片格式：PNG、JPG，5M以内</div> -->
          <el-image :src="infoForm.businessLicense" style="width: 300px; height: 150px"
            @click="look(infoForm.businessLicense)">
          </el-image>
          <!-- <upload-means
            type="0"
            @getUrl="getUrl($event, '')"
            :license="infoForm.businessLicense"
          ></upload-means> -->
        </el-form-item>
      </el-form>
      <div style="width: 10%; text-align: center; padding-bottom: 20px">
        <!-- <el-button type="primary" @click="save">确认</el-button> -->
        <el-button @click="back()">返回</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" fit="contain" :src="dialogImageUrl" alt="" style="width: 100%" />
    </el-dialog>
    <el-dialog title="选择用户" :visible.sync="dialogUser" append-to-body width="40%">
      <div style="margin-left: 10px">用户列表</div>
      <div class="dialog-search">
        <div>
          <el-input placeholder="请输入用户信息" clearable v-model="keywords"></el-input>
        </div>
        <div>
          <el-button type="primary" @click="getfindVipCustomerPage">查询</el-button>
        </div>
      </div>
      <div>
        <el-table border :data="tableData" tooltip-effect="dark" style="width: 100%; margin-top: 20px; margin-left: 10px"
          @row-click="rowClick">
          <el-table-column prop="select" width="55">
            <template slot-scope="scope">
              <el-radio v-model="radioIdSelect" :label="scope.row.id">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="用户ID" prop="id"> </el-table-column>
          <el-table-column label="用户昵称" prop="username" width="120">
          </el-table-column>
          <el-table-column prop="phone" label="电话号码" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="vipLevelName" label="用户等级" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <div style="float: right; margin-top: 10px">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
            :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
        <div style="margin-top: 60px; text-align: center">
          <el-button style="margin-right: 30px" type="primary" @click="submit">确认</el-button>
          <el-button @click="dialogUser = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerPicture from '@/components/upload/headerPicture.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
import UploadMeans from '../components/uploadMeans.vue'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册
export default {
  components: {
    quillEditor,
    UploadMeans,
    headerPicture
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      disabled: false,
      rTitle: '新增平台',
      editorOption: {},
      name: '',
      radioIdSelect: '',
      dialogUser: false,
      tableData: [
        {}, {}, {}
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      keywords: '',
      infoForm: {
        id: null,
        name: '',
        userId: '',
        logoUrl: '',
        categoryIds: '',
        intro: '',
        adminPhone: '',
        adminIdCardFront: '',
        adminIdCardContrary: '',
        businessLicense: '',
        vipLevel: '--',
        type: '0'
      },
      vipLevel: '',
      categoryList: [],
      dictionaries: {},
      infoRules: {
        userId: [
          { required: true, message: '请选择关联用户', trigger: 'change' },
        ],
        categoryIds: [
          { required: true, message: '请选择平台类目', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入平台名称', trigger: 'blur' }
        ],
        logoUrl: [
          { required: true, message: '请上传平台图片', trigger: 'change' }
        ],
        intro: [
          { required: true, message: '请输入平台简介', trigger: 'blur' }
        ],
        adminPhone: [
          { required: true, message: '请输入管理员电话', trigger: 'change' }
        ],
        adminIdCardFront: [
          { required: true, message: '请上传身份证', trigger: 'blur' }
        ],
        adminIdCardContrary: [
          { required: true, message: '请上传身份证反面', trigger: 'blur' }
        ],
      },
      time: 0
    }
  },
  watch: {
    infoForm: {
      handler(newVal, oldVal) {
        console.log(newVal)
        if (newVal.intro != '') {
          this.$refs.infoForm.clearValidate('intro')
        }
        if (newVal.adminIdCardContrary != '' && newVal.adminIdCardFront != '') {
          this.$refs.infoForm.clearValidate('adminIdCardFront')
        }
      },
      deep: true
    },
  },
  created() {
    console.log(this.$route.query.id)
    if (this.$route.query.id) {
      this.getDetail()
    }
    if (this.$route.query.type == 'add') {
      this.rTitle = '新增平台'
    } else {
      this.rTitle = '编辑平台'
    }
    this.getCategoryList()
    this.getDictionaries('platform_vip_level')
  },
  methods: {
    look(src) {
      this.dialogVisible = true
      this.dialogImageUrl = src
    },
    back() {
      this.$router.go(-1)
    },
    getDetail() {
      let params = {
        id: this.$route.query.id
      }
      this.$api.getPlatformInfo(params).then(res => {
        if (res.code == 0) {
          this.infoForm = res.data
          this.infoForm.id = this.$route.query.id
          this.infoForm.vipLevel = String(this.infoForm.vipLevel)
          this.infoForm.type = String(this.infoForm.type)
        }
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_vip_level'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    submit() {
      this.dialogUser = false
      this.infoForm.userId = String(this.radioIdSelect)
    },
    save() {
      console.log(this.infoForm)
      if (this.time == 0) {
        this.time = 3; //设定间隔时间（秒）
        //启动计时器，倒计时time秒后自动关闭计时器。
        var index = setInterval(function () {
          this.time--;
          if (this.time == 0) {
            clearInterval(index);
          }
        }, 1000);
        //此处可写要执行的代码
        if (this.$route.query.type == 'add') {
          this.$refs['infoForm'].validate((valid) => {
            if (valid) {
              this.$api.addPlatform(this.infoForm).then(res => {
                if (res.code == 0) {
                  this.disabled = true
                  this.$message({
                    type: 'success',
                    message: '添加成功'
                  })
                  this.$router.push({
                    name: 'platList',
                    query: {}
                  })
                } else {
                  this.time = 0
                }
              })
            } else {
              console.log('error submit!!');
              this.time = 0
              return false;
            }
          });

        } else {
          this.$refs['infoForm'].validate((valid) => {
            if (valid) {
              this.$api.addPlatform(this.infoForm).then(res => {
                if (res.code == 0) {
                  this.disabled = true
                  this.$message({
                    type: 'success',
                    message: '编辑成功'
                  })
                  this.$router.push({
                    name: 'platList',
                    query: {}
                  })
                } else {
                  this.time = 0
                }
              })
            } else {
              console.log('error submit!!');
              this.time = 0
              return false;
            }
          });

        }

      } else {
        console.log('目前按钮事件不允许被触发');
      }

    },
    getUrl(val, type) {
      if (type == '') {
        this.infoForm.businessLicense = val
      } else if (type == '1') {
        this.infoForm.adminIdCardFront = val
        if (this.infoForm.adminIdCardContrary != '' && this.infoForm.adminIdCardFront != '') {
          this.$refs.infoForm.clearValidate('adminIdCardContrary')
        }
      } else {
        this.infoForm.adminIdCardContrary = val
        if (this.infoForm.adminIdCardContrary != '' && this.infoForm.adminIdCardFront != '') {
          this.$refs.infoForm.clearValidate('adminIdCardContrary')
        }
      }
    },
    getImage(val) {
      this.infoForm.logoUrl = val
      this.$refs.infoForm.clearValidate('logoUrl')
    },
    onChangeCategory(val) {
      console.log(val)
    },
    // 获取类目列表
    getCategoryList() {
      const params = {}
      this.$api.categoryList(params).then((res) => {
        res.data.list.forEach(item => {
          if (item.children) {
            item.children.forEach(itm => {
              if (itm.children) {
                delete itm.children
              }
            })
          }
        })
        this.categoryList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    rowClick(row) {
      this.radioIdSelect = row.id
      this.name = "姓名：" + row.username + ';ID:' + row.id + ';电话' + row.phone
      this.infoForm.vipLevel = row.vipLevelName
      this.infoForm.adminPhone = row.phone
      // this.addressInfo.name = row.name
      // this.addressInfo.phone = row.phone
      // this.addressInfo.address = row.address
    },
    handleCurrentChange(currentChange) {
      this.page = currentChange
      this.getfindVipCustomerPage()
    },
    handleSizeChange(sizeChange) {
      this.pageSize = sizeChange
      this.getfindVipCustomerPage()
    },
    selectUser() {
      this.dialogUser = true
      this.getfindVipCustomerPage()
    },
    getfindVipCustomerPage() {
      let data = {
        pageNo: this.page,
        pageSize: this.pageSize,
        keywords: this.keywords
      }
      this.$api.findVipCustomerPage(data).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.list
          this.total = res.data.totalNum
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
<style scoped>
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
</style>
